// Date formatting-related functions
import * as moment from 'moment';
import {
    DATETIME_FORMAT_CHAT_TIMESTAMP, DATETIME_FORMAT_LOCALIZED_FULL,
    DATETIME_FORMAT_LOCALIZED_SHORT, DATETIME_FORMAT_FULL
} from '../constants';

function formatDate(date, format) {
    return moment(date).format(format);
}

export function formatToFullLocalizedDate(date) {
    return formatDate(date, DATETIME_FORMAT_LOCALIZED_FULL);
}

export function formatToShortLocalizedDate(date) {
    return formatDate(date, DATETIME_FORMAT_LOCALIZED_SHORT);
}

export function formatToChatTime(date) {
    return formatDate(date, DATETIME_FORMAT_CHAT_TIMESTAMP);
}

export function formatToFullDate(date) {
    return formatDate(date, DATETIME_FORMAT_FULL);
}

export function timestampToFullDate(ts) {
    const date = moment.unix(ts);
    return formatDate(date, DATETIME_FORMAT_FULL);
}

export function secondsToDuration(seconds) {
    return new Date(seconds * 1000).toISOString().substr(11, 8);
}
